import { IonIcon, IonItem, IonLabel, IonNote, IonText } from "@ionic/react";
import { useAppContext } from "../../services/app-context.service";
import { person, callOutline } from "ionicons/icons";
import "./UserProfile.scss";

const UserProfile: React.FC = () => {
    const { user } = useAppContext();

    return (
        <div id="profile">
            <div className="info">
                <IonItem lines="none">
                    <div slot="start" className="label">
                        <IonIcon icon={person} />
                        <IonLabel>Name</IonLabel>
                    </div>
                    <IonText>{user.name}</IonText>
                </IonItem>
                <IonItem lines="none">
                    <div slot="start" className="label">
                        <IonIcon icon={callOutline} />
                        <IonLabel>Phone</IonLabel>
                    </div>
                    <IonText>{user.phone}</IonText>
                </IonItem>
                <IonItem lines="none" className="warning-note-item">
                    <IonNote>
                        Make sure you use "{user.phone}". If you don't, please update your phone number to secure your account. For security, passwords can be reset via the logout screen.
                    </IonNote>
                </IonItem>
            </div>
        </div>
    );
};

export default UserProfile;
